import styled, { css } from "styled-components";
import { borderRadius, spacing, typographyMixin, rawColors } from "@magicbi/ui-library";
import { fontSizes, fontWeights } from "../../../design-system/tokens/typography";
import type { SaveStatusLabelAppearance, SaveStatusLabelStatus } from "./SaveStatusLabel.types";

/** F05 tones: saved = positive text, saving = primary-700, error = strong negative text. */
const toneColor = (status: SaveStatusLabelStatus) =>
  status === "error"
    ? rawColors.accent.negative.textStrong
    : status === "saved"
      ? rawColors.accent.positive.text
      : rawColors.primary[700];

export const Root = styled.span<{ $status: SaveStatusLabelStatus; $appearance: SaveStatusLabelAppearance }>`
  display: inline-flex;
  align-items: center;
  /* The saved check carries its own space (F07: "✓ Saved"), so no flex gap there. */
  gap: ${({ $status }) => ($status === "saved" ? 0 : spacing[1.5])};
  white-space: nowrap;
  color: ${({ $status }) => toneColor($status)};
  ${typographyMixin("caption", 3)}
  font-size: ${fontSizes[12]};
  font-weight: ${fontWeights.semibold};

  ${({ $appearance, $status, theme }) =>
    $appearance === "chip" &&
    css`
      height: 1.375rem;
      padding: 0 ${spacing[2]};
      border-radius: ${borderRadius.md};
      background: ${$status === "error" ? theme.colors.error[50] : theme.colors.background.tertiary};
    `}
`;

export const Retry = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 1.125rem;
  padding: 0 ${spacing[1.5]};
  border-radius: ${borderRadius.sm};
  background: ${({ theme }) => theme.colors.background.primary};
  color: inherit;
  ${typographyMixin("caption", 3)}

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.text.link};
  }
`;
